<div class="grid gap-3 m-3">
  <div>
    <a mat-raised-button routerLink="..">Back To Dashboard</a>
  </div>
  <div>
    <div class="bg-white rounded card-with-shadow p-2 grid grid-cols-3 gap-2">
      <mat-form-field>
        <mat-label>Region</mat-label>
        <mat-select [formControl]="regionControl">
          <mat-option *ngFor="let region of regions$ | async; trackBy: 'id' | trackByKey" [value]="region.ID">
            {{ region.Name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Experience</mat-label>
        <mat-select [formControl]="experienceControl">
          <mat-option
            *ngFor="let experience of experiences$ | async; trackBy: experiences$ | trackByKey2: 'id'"
            [value]="experience.id"
          >
            {{ experience.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Start And End</mat-label>
        <mat-date-range-input [rangePicker]="picker">
          <input matStartDate [formControl]="startControl" placeholder="Start date" />
          <input matEndDate [formControl]="endControl" placeholder="End date" />
        </mat-date-range-input>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
      <div class="grid grid-cols-3 gap-3 col-span-2" *ngIf="subcontractors$$ | async as subcontractors">
        <ng-container *ngIf="subcontractors.length > 0">
          <mat-form-field>
            <mat-label>Subcontractor</mat-label>
            <mat-select [formControl]="subControl">
              <mat-option *ngFor="let sub of subcontractors; trackBy: 'id' | trackByKey" [value]="sub.id">
                {{ sub.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Percentage</mat-label>
            <input lohiNumberInput [formControl]="percentControl" autocomplete="off" [noDecimals]="false" matInput />
            <span matSuffix>%</span>
          </mat-form-field>
          <button mat-raised-button (click)="updatePercentages()">Fill Shift Counts</button>
          <div class="col-span-3 flex w-full">
            <mat-form-field class="mr-1 w-full">
              <mat-label>Orders Per Shift</mat-label>
              <input lohiNumberInput [formControl]="turnRateControl" autocomplete="off" [noDecimals]="false" matInput />
            </mat-form-field>
            <button class="ml-1 w-full" mat-raised-button (click)="updateTurnRate()">Fill Orders Per Shift</button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="grid grid-cols-2 gap-3" *ngIf="estimatedOrders$$ | async as est">
    <div class="bg-white rounded card-with-shadow p-2 flex flex-col">
      Estimated Orders Per Shift In Region
      {{ est }}
    </div>
    <div class="bg-white rounded card-with-shadow p-2 flex flex-col">
      <button mat-raised-button color="primary" (click)="promptFileUpload()">Upload Order Counts</button>
    </div>
  </div>
  <div [formGroup]="group" *ngFor="let group of dates; trackBy: 'null' | trackByKey">
    <div class="bg-white rounded card-with-shadow p-2 flex flex-col">
      <div class="text-xl font-bold flex-col flex w-full mb-3">
        {{ group.value.date.split('T')[0] }} Total Shift Count: {{ getSum(group.controls.carriers) | number }}/{{
          group.value.orderCount / group.value.orderCountPerShift | ceil
        }}
        <ng-container *ngIf="getSum(group.controls.carriers) > group.value.orderCount / group.value.orderCountPerShift">
          <div class="text-red-500">Allocated Shifts Exceeds Total Shifts</div>
        </ng-container>
      </div>
      <div class="grid grid-cols-2 gap-3">
        <mat-form-field>
          <mat-label>Order Count</mat-label>
          <input lohiNumberInput [noDecimals]="true" formControlName="orderCount" autocomplete="off" matInput />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Orders Per Shift</mat-label>
          <input type="number" formControlName="orderCountPerShift" autocomplete="off" matInput />
        </mat-form-field>
      </div>

      <div class="grid grid-cols-4 gap-2">
        <ng-container
          *ngFor="let control of $any(group.controls.carriers).controls; let i = index; trackBy: null | trackByKey"
          formArrayName="carriers"
        >
          <ng-container [formGroupName]="i">
            <div class="flex flex-col">
              <div class="text-lg font-semibold items-center flex mr-1">
                {{ control.value.carrierName }}
                <ng-container *ngIf="control.value.shiftCount"></ng-container>
              </div>
              <mat-form-field>
                <mat-label>Shift Count</mat-label>
                <input lohiNumberInput [noDecimals]="true" formControlName="shiftCount" autocomplete="off" matInput />
              </mat-form-field>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>

  <div class="flex justify-start">
    <button mat-raised-button color="primary" (click)="submit()">Submit</button>
  </div>
</div>
